<template>
<div>
  <van-field required readonly right-icon="arrow" name="picker" input-align="right" :value="pfjdValue" label="排放阶段" placeholder="点击选择排放阶段" 
              @click="showZhoushuPickerPop" :rules="[{ validator:validator, message: '请选择排放阶段' }]">
    <template #label>
      <span class="input-left-label-hq">排放阶段</span>
    </template>
  </van-field>
  <van-popup v-model="showZhouShuPicker" position="bottom">
    <van-picker title="标题" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
  </van-popup>
</div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      columns: ['国一', '国二', '国三', '国四', '国五', '国六'],
      showZhouShuPicker: false,
    };
  },
  props:{
    pfjdValue: {
      type: String,
      default: ""
    },
    pickRequire:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    showZhoushuPickerPop() {
      this.showZhouShuPicker = true;
    },
    onConfirm(value) {
      this.$emit('getPfjd', value)
      this.onCancel()
    },
    onCancel() {
      this.showZhouShuPicker = false;
    },
    validator(val) {
      if (this.pickRequire) {
        if (!val) {
          Toast.fail('请填写排放阶段');
          return false;
        }
        return val;
      }
    },
  },
};
</script>
